import styles from '@styles/Popup.module.css'
import PropTypes from 'prop-types'

const Popup = ({ message }) => {
  return (
    <div className={styles.popup}>
      <p>{message}</p>
    </div>
  )
}

Popup.propTypes = {
  message: PropTypes.string.isRequired,
}

export default Popup
